import React from 'react';
import { useTranslation } from 'react-i18next';

export interface SubscriptionSuccessPopupProps {
  open: boolean;
  onClose: () => void;
}

const SubscriptionSuccessPopup: React.FC<SubscriptionSuccessPopupProps> = ({ open, onClose }) => {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40"
      role="dialog"
      aria-modal="true"
      aria-labelledby="subscription-success-title"
    >
      <div
        className="bg-white rounded-2xl shadow-xl max-w-sm w-full overflow-hidden"
        style={{ direction: document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr' }}
      >
        <div className="px-6 pt-6 pb-2 text-center">
          <div
            className="mx-auto w-14 h-14 rounded-full flex items-center justify-center text-3xl mb-4"
            style={{ background: 'linear-gradient(135deg, #D1FAE5 0%, #A7F3D0 100%)' }}
            aria-hidden
          >
            ✓
          </div>
          <h2 id="subscription-success-title" className="text-xl font-bold text-gray-900 mb-2">
            {t('payments_congratulations_title', 'Congratulations!')}
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed">
            {t(
              'payments_congratulations_message',
              'Your subscription is now active. You have full access to the content.',
            )}
          </p>
        </div>
        <div className="px-6 pb-6 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="w-full py-3 px-4 rounded-xl font-semibold text-white transition opacity hover:opacity-90"
            style={{ backgroundColor: '#1A1A2E' }}
          >
            {t('payments_congratulations_close', 'Got it')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccessPopup;
